import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';

export const GuaranteePage: React.FC = () => {
  const { lang } = useTranslation();

  if (lang === 'cs') {
    return (
      <div className="guarantee-page">
        <h2>Garance Rondoshare</h2>

        <p>
          V Rondoshare chceme poskytnout maximální jistotu majitelům půjčovaných předmětů i zákazníkům, co si něco půjčují.
          Proto je každý pronájem krytý garancí Rondoshare, která zajišťuje náhradu v případě
          neúmyslného poškození nebo krádeže. Garance je dobrovolný závazek Rondoshare, nejde o pojištění.
        </p>
        <p>
          Na této stránce najdete shrnutí. Závazné podmínky garance jsou v{' '}
          <Link to="/terms">obchodních podmínkách</Link> (článek 7A).
        </p>

        <h3>Jistoty pro zákazníka</h3>
        <p>Půjčovné se nikdy neplatí přímo majiteli. Platí se vždy bezpečně prostřednictvím platformy.
          Díky tomu se můžete spolehnout, že pokud majitel zruší půjčení, dostanete peníze zpátky.
          Majitel dostane peníze na účet až po dokončení pronájmu.</p>
        <p>Díky tomu, že všechny transakce probíhají přes naši platformu, nemusíte se bát podvodů ze strany majitele.</p>
        <h3>Jistoty pro majitele</h3>
        <p>Všichni uživatelé oprávnění k půjčení předmětu mají ověřenou identitu přes MojeID nebo osobně
          od správce Rondoshare. Nepůjčujete tedy anonymním uživatelům,
          ale skutečným lidem, kteří nebudou riskovat podvody. Uzavíráte právně závaznou smlouvu se zákazníkem.</p>
        <p>V případě, že přesto dojde ke škodě, ať už kvůli nedopatření nebo špatným úmyslům, Rondoshare vám zajistí náhradu.</p>

        <section>
          <h3>Fotky při předání a vrácení</h3>
          <p>
            Při předání i vrácení předmětu vyplníte v detailu objednávky předávací protokol a přiložíte
            fotky předmětu. Protokol nejde odeslat bez alespoň jedné fotky. Fotky jsou podmínkou garance:
            podle nich posoudíme, v jakém stavu byl předmět předán a v jakém se vrátil.
          </p>
          <p>
            Vyfoťte předmět ze všech stran, včetně příslušenství a případných drobných vad, které už má.
            Fotky vidí jen vy, druhá strana pronájmu a Rondoshare a nejde je smazat.
          </p>
        </section>

        <section>
          <h3>Podmínky garance</h3>
          <p>
            Náhrada je omezena hodnotou předmětu uvedenou v inzerátu v době rezervace,
            nejvýše 20 000 Kč za jeden pronájem. Kryté jsou jen předměty a příslušenství
            uvedené v inzerátu nebo v předávacím protokolu.
          </p>
          <p>Co není kryto garancí Rondoshare</p>
          <ul>
            <li>Kosmetické poškození, které neomezuje funkci (škrábance, skvrny)</li>
            <li>Běžné opotřebení normálním používáním (např. sjetý řetěz, otupený vrták atd.)</li>
            <li>Náklady na čištění</li>
            <li>Spotřebované palivo nebo jiné spotřební materiály, jako např. brusný papír nebo olej.</li>
            <li>Poškození, které bylo už před půjčením předmětu.</li>
            <li>Škody, které způsobil sám majitel, a škody při přepravě dopravcem</li>
          </ul>
          <p>
            Garance se nevztahuje na poškození nebo krádež, které se staly při zapůjčení
            předmětu přes Rondoshare mimo období, kdy byl předmět zapůjčený.
          </p>
          <p>Garance nepokrývá ušlé zisky během vyřízení opravy nebo náhrady.</p>
          <p>
            V případě, že dojde k záměrnému poškození, poškození hrubou nedbalostí, ztrátě,
            podvodu nebo krádeži nájemcem, Rondoshare bude vymáhat náhradu škod přímo od nájemce.
          </p>
        </section>

        <section>
          <h3>Co dělat, když se něco rozbije?</h3>
          <p>
            Viditelné poškození zapište do protokolu o vrácení při převzetí předmětu. Vadu, kterou při
            převzetí nešlo zjistit (třeba že předmět při dalším použití nefunguje), nám oznamte na{' '}
            <a href="mailto:info@rondoshare.com">info@rondoshare.com</a> nejpozději do 7 dnů od vrácení.
            Popište závadu a přiložte fotografie a doklad o hodnotě předmětu (např. účtenku nebo odkaz
            na srovnatelnou nabídku). Dohodneme se s vámi na dalším postupu.
          </p>
          <p>
            V případě, že věc půjde opravit, proplatíme náklady na opravu. V případě, že ne,
            proplatíme nákup ekvivalentního použitého produktu. Peníze posíláme po doložení účtenky
            za opravu nebo za náhradní předmět.
          </p>
        </section>

        <section>
          <h3>Co dělat, když je nájemce obětí krádeže?</h3>
          <p>
            Nejprve musí nájemce ohlásit krádež na policii. Potom se nám ozvěte na{' '}
            <a href="mailto:info@rondoshare.com">info@rondoshare.com</a>, nejpozději do 7 dnů od konce
            pronájmu. Přiložte kopii policejního protokolu a dohodneme se na dalším postupu. S výplatou
            můžeme počkat až 30 dní, aby policie mohla předmět dohledat.
          </p>
        </section>

        <section>
          <h3>Co dělat v případě, že nájemce věc ztratí?</h3>
          <p>
            V případě ztráty je nájemce odpovědný za náhradu škody. Můžete se dohodnout přímo
            s nájemcem na kompenzaci. Pokud se nedohodnete, kontaktujte nás na{' '}
            <a href="mailto:info@rondoshare.com">info@rondoshare.com</a>. Rondoshare vám zajistí
            náhradu a bude škodu vymáhat od nájemce.
          </p>
        </section>
      </div>
    );
  }

  return (
    <div className="guarantee-page">
      <h2>Rondoshare Guarantee</h2>

      <p>
        At Rondoshare, we want to provide maximum security to owners of rented items.
        That's why every rental is covered by the Rondoshare Guarantee, which ensures
        compensation in case of unintentional damage or theft. The Guarantee is a voluntary
        commitment of Rondoshare, not insurance.
      </p>
      <p>
        This page is a summary. The binding conditions of the Guarantee are set out in the{' '}
        <Link to="/terms">Terms and Conditions</Link> (article 7A).
      </p>

      <h3>Security for the customer</h3>
      <p>
        The rental fee is never paid directly to the owner. It is always paid by card through
        our regulated payment partner Stripe, and Rondoshare never holds your money. This way,
        you can be sure that if the owner cancels the rental, you will get your money back.
        The owner can withdraw the money to their bank account only after the rental is completed.
      </p>
      <p>
        Because all transactions are conducted through our platform, you don't have to worry
        about fraud from the owner's side.
      </p>

      <h3>Security for the owner</h3>
      <p>
        All users authorized to rent an item have their identity verified through MojeID or in person
        by a Rondoshare administrator. So you are not renting
        to anonymous users, but to real people who will not risk committing fraud. You are entering
        into a legally binding agreement with the customer.
      </p>
      <p>
        In case damage occurs, whether by accident or due to malicious intent, Rondoshare will
        ensure compensation for you.
      </p>
      <section>
        <h3>Photos at pickup and return</h3>
        <p>
          At pickup and at return, you fill in the handover report in the order details and attach
          photos of the item. The report cannot be submitted without at least one photo. Photos are a
          condition of the Guarantee: they show the condition of the item when it was handed over and
          when it came back.
        </p>
        <p>
          Photograph the item from all sides, including accessories and any minor defects it already has.
          Only you, the other party of the rental and Rondoshare can see the photos, and they cannot be deleted.
        </p>
      </section>

      <section>
        <h3>Guarantee conditions</h3>
        <p>
          Compensation is limited to the item's value stated in the listing when the booking was made,
          up to 20,000 Kč per rental. Only items and accessories listed in the listing or in the
          handover report are covered.
        </p>
        <p>What is not covered by the Rondoshare Guarantee</p>
        <ul>
          <li>Cosmetic damage that does not affect function (scratches, stains)</li>
          <li>Normal wear and tear from regular use (e.g. worn chain, dulled drill bit, etc.)</li>
          <li>Cleaning costs</li>
          <li>Consumed fuel or other consumable materials, such as sandpaper or oil.</li>
          <li>Damage that existed before the item was rented.</li>
          <li>Damage caused by the owner, and damage during transport by a carrier</li>
        </ul>
        <p>
          The guarantee only applies to damage or theft that occurred while the item
          was rented through Rondoshare during the rental period.
        </p>
        <p>The guarantee does not cover lost profits during the repair or replacement process.</p>
        <p>
          In the case of intentional damage, damage caused by gross negligence, loss,
          fraud, or theft by the renter, Rondoshare will seek compensation directly from the renter.
        </p>
      </section>

      <section>
        <h3>What to do if something breaks?</h3>
        <p>
          Record visible damage in the return report when you take the item back. A defect that could not
          be noticed at that point (for example, the item does not work the next time it is used) can be
          reported to{' '}
          <a href="mailto:info@rondoshare.com">info@rondoshare.com</a> within 7 days of the return.
          Describe the issue and attach photos and proof of the item's value (e.g. a receipt or a link
          to a comparable offer). We will agree on the next steps with you.
        </p>
        <p>
          If the item can be repaired, we will reimburse the repair costs. If not, we will reimburse
          the purchase of an equivalent used product. We pay out once you send us the receipt for the
          repair or the replacement.
        </p>
      </section>

      <section>
        <h3>What to do if the renter is a victim of theft?</h3>
        <p>
          First, the renter must report the theft to the police. Then contact us at{' '}
          <a href="mailto:info@rondoshare.com">info@rondoshare.com</a> within 7 days of the end of the
          rental. Attach a copy of the police report and we will agree on the next steps. We may wait up
          to 30 days before paying out so that the police can try to recover the item.
        </p>
      </section>

      <section>
        <h3>What to do if the renter loses the item?</h3>
        <p>
          In case of loss, the renter is responsible for compensation. You can agree directly
          with the renter on compensation. If you cannot reach an agreement, contact us at{' '}
          <a href="mailto:info@rondoshare.com">info@rondoshare.com</a>. Rondoshare will
          ensure compensation for you and will seek damages from the renter.
        </p>
      </section>
    </div>
  );
};
